// Types for our configuration
type Currency = "USD" | "GBP";
type Frequency = "one-time" | "monthly";

interface DonationLink {
  amount: string;
  frequency: Frequency;
  hrefValuesByCurrency: {
    [key in Currency]: string;
  };
}

export const config = {
  defaultDonationAmount: "200",
  defaultDonationFrequency: "one-time" as Frequency,
  liveDonationLinks: [
    {
      amount: "25",
      frequency: "one-time",
      hrefValuesByCurrency: {
        GBP: "https://donate.stripe.com/bIYg2J3Ysegu0aQ3ct",
        USD: "https://donate.stripe.com/4gwbM5do2bEu0SceUV",
      },
    },
    {
      amount: "100",
      frequency: "one-time",
      hrefValuesByCurrency: {
        GBP: "https://donate.stripe.com/dR603LcuY3BQcXC4gw",
        USD: "https://donate.stripe.com/9AQg2lcjYcIy58s7su",
      },
    },
    {
      amount: "200",
      frequency: "one-time",
      hrefValuesByCurrency: {
        GBP: "https://donate.stripe.com/aEUg2JfHagoCf5K00f",
        USD: "https://donate.stripe.com/28oeYhfwa8siasMeUX",
      },
    },
    {
      amount: "500",
      frequency: "one-time",
      hrefValuesByCurrency: {
        GBP: "https://donate.stripe.com/6oE8AhbqU2xMbTydR0",
        USD: "https://donate.stripe.com/9AQg2labQfUKasMcMQ",
      },
    },
    {
      amount: "other",
      frequency: "one-time",
      hrefValuesByCurrency: {
        GBP: "https://donate.stripe.com/6oE5o59iM0pE9Lq3cl",
        USD: "https://donate.stripe.com/8wMcQ9do2dMCbwQ000",
      },
    },
    {
      amount: "25",
      frequency: "monthly",
      hrefValuesByCurrency: {
        GBP: "https://buy.stripe.com/6oE03L8eI6O20aQbIW",
        USD: "https://donate.stripe.com/5kA8zT83IcIyeJ2bIN",
      },
    },
    {
      amount: "100",
      frequency: "monthly",
      hrefValuesByCurrency: {
        GBP: "https://buy.stripe.com/28o17P8eI5JY8HmeV6",
        USD: "https://donate.stripe.com/5kAaI1gAe23UcAU006",
      },
    },
    {
      amount: "200",
      frequency: "monthly",
      hrefValuesByCurrency: {
        GBP: "https://buy.stripe.com/4gw8AhbqU8Wae1G28j",
        USD: "https://donate.stripe.com/6oE03n2JobEubwQfZ5",
      },
    },
    {
      amount: "500",
      frequency: "monthly",
      hrefValuesByCurrency: {
        GBP: "https://buy.stripe.com/bIYbMt52w8Waf5K8wJ",
        USD: "https://donate.stripe.com/28oeYhcjYdMCeJ25ks",
      },
    },
  ] as DonationLink[],
  paymentEnvironment: (process.env.NEXT_PUBLIC_PAYMENT_ENVIRONMENT as "test" | "live") || "test",
  testDonationLinks: [
    {
      amount: "25",
      frequency: "one-time",
      hrefValuesByCurrency: {
        GBP: "https://donate.stripe.com/bIYg2J3Ysegu0aQ3ct",
        USD: "https://donate.stripe.com/4gwbM5do2bEu0SceUV",
      },
    },
    {
      amount: "100",
      frequency: "one-time",
      hrefValuesByCurrency: {
        GBP: "https://donate.stripe.com/dR603LcuY3BQcXC4gw",
        USD: "https://donate.stripe.com/9AQg2lcjYcIy58s7su",
      },
    },
    {
      amount: "200",
      frequency: "one-time",
      hrefValuesByCurrency: {
        GBP: "https://donate.stripe.com/aEUg2JfHagoCf5K00f",
        USD: "https://donate.stripe.com/28oeYhfwa8siasMeUX",
      },
    },
    {
      amount: "500",
      frequency: "one-time",
      hrefValuesByCurrency: {
        GBP: "https://donate.stripe.com/6oE8AhbqU2xMbTydR0",
        USD: "https://donate.stripe.com/9AQg2labQfUKasMcMQ",
      },
    },
    {
      amount: "other",
      frequency: "one-time",
      hrefValuesByCurrency: {
        GBP: "https://donate.stripe.com/6oE5o59iM0pE9Lq3cl",
        USD: "https://donate.stripe.com/8wMcQ9do2dMCbwQ000",
      },
    },
    {
      amount: "25",
      frequency: "monthly",
      hrefValuesByCurrency: {
        GBP: "https://buy.stripe.com/6oE03L8eI6O20aQbIW",
        USD: "https://donate.stripe.com/5kA8zT83IcIyeJ2bIN",
      },
    },
    {
      amount: "100",
      frequency: "monthly",
      hrefValuesByCurrency: {
        GBP: "https://buy.stripe.com/28o17P8eI5JY8HmeV6",
        USD: "https://donate.stripe.com/5kAaI1gAe23UcAU006",
      },
    },
    {
      amount: "200",
      frequency: "monthly",
      hrefValuesByCurrency: {
        GBP: "https://buy.stripe.com/4gw8AhbqU8Wae1G28j",
        USD: "https://donate.stripe.com/6oE03n2JobEubwQfZ5",
      },
    },
    {
      amount: "500",
      frequency: "monthly",
      hrefValuesByCurrency: {
        GBP: "https://buy.stripe.com/bIYbMt52w8Waf5K8wJ",
        USD: "https://donate.stripe.com/28oeYhcjYdMCeJ25ks",
      },
    },
  ] as DonationLink[],
};

// Export the types for use in other files
export type { Currency, DonationLink, Frequency };
